<template>
  <div class="custom-applied-payment-notify-component">
    <div class="custom-applied-payment-notify-component__message m-t-20 m-b-20">
      {{ message }}
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AppAppliedPaymentNotifier",
  props: {
    messageId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      message: ""
    };
  },
  methods: {
    ...mapActions("messages", ["removeMessages"])
  },
  computed: {
    ...mapGetters({
      getMessage: "messages/getMessageById"
    }),
    ...mapGetters("vendor", ["getActiveVendor"])
  },
  mounted() {
    this.message = this.getMessage(this.messageId)["message"];
    this.removeMessages([this.messageId]);
  }
};
</script>

<style lang="scss">
.menu-itme-fav-notifier {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border: solid 1px #e3e3e3;
}
</style>
<style scoped lang="scss">
.custom-applied-payment-notify-component {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  background-color: $primary-color;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border: solid 1px #e3e3e3;
  color: #333;
  font-weight: 500;
  height: 70px;

  &__message {
    font-weight: bolder;
  }

  @include respond-to-mobile {
    font-size: 0.9em;
  }
}
</style>
